import { useEffect, useRef } from "react";

interface HoverAwayListenerProps {
  children: React.ReactNode;
  onHoverAway: (event: MouseEvent) => void;
}

const HoverAwayListener: React.FC<HoverAwayListenerProps> = ({
  children,
  onHoverAway,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleMouseMove = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onHoverAway(event);
      }
    };

    document.addEventListener("mousemove", handleMouseMove);
    // return () => document.removeEventListener("mousemove", handleMouseMove);
  }, [onHoverAway]);

  return <div ref={ref}>{children}</div>;
};

export default HoverAwayListener;
